import React, { useState } from 'react';
import './Careers.css';
import { submitFormspark } from '../utils/formspark';
import MarketingConsent from '../components/MarketingConsent';

const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const Careers = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    message: '',
    resumeLink: '',
    marketingOptIn: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await submitFormspark({
        form: 'careers',
        fullName: formData.fullName,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        message: formData.message,
        resumeLink: formData.resumeLink,
        marketingOptIn: formData.marketingOptIn ? 'Yes' : 'No'
      });

      setSubmitStatus('success');
      setFormData({
        fullName: '',
        email: '',
        phoneNumber: '',
        message: '',
        resumeLink: '',
        marketingOptIn: false
      });
    } catch (error) {
      console.error('Careers application submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }

    scrollToTop();
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="careers-container">
      <h1 className="careers-title">Join a growing team with a love for food</h1>

      {submitStatus === 'success' && (
        <div className="success-message">
          Thank you! We received your application details. Please email your resume to <a href="mailto:drakessancarlos@gmail.com">drakessancarlos@gmail.com</a> so we can complete your submission.
        </div>
      )}

      {submitStatus === 'error' && (
        <div className="error-message">
          Something went wrong while sending your application. Please try again or contact us directly.
        </div>
      )}

      <section className="careers-info">
        <h2>Why work with us?</h2>
        <p>We are always hiring A players who work hard, love helping others, and do great work. Fill out the 2 minute form below with your background and a few sentences about you.</p>
      </section>

      <div className="location">
        <h2>Location</h2>
        <p>Drakes<br />1101 San Carlos Avenue</p>
      </div>

      <section className="application-section">
        <h2>Application</h2>
        <form onSubmit={handleSubmit} className="careers-form">
          <div className="form-group">
            <label htmlFor="fullName">Full Name<span className="required">*</span></label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Full name"
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email<span className="required">*</span></label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="phoneNumber">Phone Number<span className="required">*</span></label>
            <input
              type="tel"
              id="phoneNumber"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              placeholder="(555) 555-5555"
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="resumeLink">Resume or Portfolio Link</label>
            <input
              type="url"
              id="resumeLink"
              name="resumeLink"
              value={formData.resumeLink}
              onChange={handleChange}
              placeholder="https://"
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Anything to share as we consider your application?</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              placeholder="Message"
              disabled={isSubmitting}
            />
          </div>

          <div className="attachment-notice">
            <h3>Resume / Cover Letter</h3>
            <p>Please email your resume and/or cover letter (PDF format) to <a href="mailto:drakessancarlos@gmail.com">drakessancarlos@gmail.com</a> after submitting this form. Include the same name you used above so we can match your documents.</p>
            <p className="note">If you have a shareable link, add it in the field above.</p>
          </div>

          <MarketingConsent
            id="careers-marketing-opt-in"
            checked={formData.marketingOptIn}
            onChange={handleChange}
            disabled={isSubmitting}
          />

          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit Application'}
          </button>
        </form>
      </section>
    </div>
  );
};

export default Careers; 